module.exports = __webpack_public_path__ + "img/gold.70e330e1.jpg";